<template>
  <div id="disciplineMain">
    <div class="row">
      <div class="col-8 col-sm-12 col-md-9 col-lg-10 col-xl-7">
        <Title :page="page" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <bread-crumb :page="page" />
      </div>
    </div>
    <!-- Separator -->
    <div class="col-12 dropdown-divider pb-3" />
    <div class="row">
      <div class="col-12">
        <section-title content="Búsqueda" />
        <div class="col-12 dropdown-divider mt-0" />
      </div>
    </div>
    <ValidationObserver ref="formObserver">
      <form ref="searchLocationForm" class="main-content mt-2" novalidate>
        <div class="row mx-2">
          <div class="col-4 pt-1 pr-5">
            <div class="form-group">
              <ValidationProvider
                v-slot="{ errors, dirty }"
                name="AnioAcademico"
                rules="required"
              >
                <CustomDropDown
                  id="cboAnioAcademico"
                  label="Año Académico:"
                  placeholder="Todos"
                  :options="objectYear"
                  fieldkey="id"
                  fieldname="name"
                />
              </ValidationProvider>
            </div>
          </div>
          <div class="col-4 pt-1 pr-5">
            <div class="form-group">
              <ValidationProvider
                v-slot="{ errors, dirty }"
                name="Region"
                rules="required"
              >
                <CustomDropDown
                  id="cboRegion"
                  label="Región:"
                  placeholder="Todos"
                  :options="objectRegion"
                  fieldkey="id"
                  fieldname="name"
                />
              </ValidationProvider>
            </div>
          </div>
          <div class="col-4 pt-1 pr-5">
            <div class="form-group">
              <ValidationProvider
                v-slot="{ errors, dirty }"
                name="Distrito"
                rules="required"
              >
                <CustomDropDown
                  id="cboDistrito"
                  label="Distrito:"
                  placeholder="Todos"
                  :options="objectDistrict"
                  fieldkey="id"
                  fieldname="name"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="row mx-2">
          <div class="col-4 pt-1 pr-5">
            <div class="form-group">
              <ValidationProvider
                v-slot="{ errors, dirty }"
                name="Escuela"
                rules="required"
              >
                <CustomDropDown
                  id="cboEscuela"
                  label="Escuela:"
                  placeholder="Todos"
                  :options="objectSchool"
                  fieldkey="id"
                  fieldname="name"
                />
              </ValidationProvider>
            </div>
          </div>
          <div class="col-4 pt-1 pr-5">
            <div class="form-group">
              <ValidationProvider
                v-slot="{ errors, dirty }"
                name="Estatus"
                rules="required"
              >
                <CustomDropDown
                  id="cboEstatus"
                  label="Estatus:"
                  placeholder="Todos"
                  :options="objectStatus"
                  fieldkey="id"
                  fieldname="name"
                />
              </ValidationProvider>
            </div>
          </div>
          <div class="col-4 pt-1">
            <action-button variant="success" class="px-4 mt-4">
              Buscar
            </action-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <div class="row mt-3">
      <div class="col-12">
        <section-title content="Resultados" />
        <div class="col-12 dropdown-divider mt-0" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <vue-good-table
          mode="remote"
          style-class="table custom-main-table"
          :columns="tableConfig.columns"
          :rows="disciplineRecords"
          :total-rows="tableConfig.totalRecords"
          :pagination-options="{
            enabled: true,
          }"
          :sort-options="{
            enabled: false,
          }"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
        >
          <div slot="emptystate">
            <div>
              No resultados disponibles
            </div>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.label == 'Escuelas'" class="school">
              {{ props.row.school.id + ' ' + props.row.school.name }}
            </span>
            <span
              v-if="
                props.column.label == '' && props.row.status == 'No Reportada'
              "
            >
              <ActionButton variant="custom-btn-report m-2">
                Reportar
              </ActionButton>
            </span>
            <span v-else class="info">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
          <template slot="pagination-bottom" slot-scope="props">
            <customPager
              ref="historyPager"
              :per-page="tableConfig.serverParams.perPage"
              :total="props.total"
              :page-changed="props.pageChanged"
              :per-page-changed="props.perPageChanged"
            />
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Title from '@/components/common/page/Title';
import BreadCrumb from '@/components/common/page/BreadCrumb';
import { SectionTitle } from '@/components/pei/shared';
import CustomDropDown from '@/components/common/CustomDropDown';
import ActionButton from '@/components/common/ActionButton';

export default {
  name: 'ReportSchoolsDiscipline',
  components: {
    ValidationProvider,
    ValidationObserver,
    Title,
    BreadCrumb,
    SectionTitle,
    CustomDropDown,
    ActionButton,
  },
  data: () => ({
    page: {
      icon: 'fas fa-user-circle',
      title: 'Reportar Escuelas sin Disciplina',
      routes: ['Inicio', 'Estudiante', 'Reportar Escuelas sin Disciplina'],
    },
    tableConfig: {
      totalRecords: 1,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 1,
      },
      columns: [],
    },
    disciplineRecords: [
      {
        school: { id: '99121', name: 'Academia Alexandra' },
        discipline: '1',
        status: 'Reportada',
      },
      {
        school: { id: 'PR094', name: 'Colegio Nuestra Señora de la Valvanera' },
        discipline: '0',
        status: 'No Reportada',
      },
      {
        school: {
          id: '54862',
          name: 'Especializada en Ciencias y Matemáticas',
        },
        discipline: '3',
        status: 'Reportada',
      },
    ],
    objectYear: [
      { id: 1, name: '2020-01' },
      { id: 2, name: '2020-02' },
    ],
    objectRegion: [
      { id: 1, name: 'Region 01' },
      { id: 2, name: 'Region 02' },
    ],
    objectDistrict: [
      { id: 1, name: 'Distrito 01' },
      { id: 2, name: 'Distrito 02' },
    ],
    objectSchool: [
      { id: 1, name: 'Escuela 01' },
      { id: 2, name: 'Escuela 02' },
    ],
    objectStatus: [
      { id: 1, name: 'Estatus 01' },
      { id: 2, name: 'Estatus 02' },
    ],
  }),
  methods: {
    onPageChange() {},
    onSortChange() {},
    onColumnFilter() {},
    onPerPageChange() {},
    initColumns() {
      let tempColumns = [
        {
          label: 'Escuelas',
          field: 'school.id + school.name',
        },
        {
          label: 'Disciplinas Reportadas',
          field: 'discipline',
        },
        {
          label: 'Estatus',
          field: 'status',
        },
        {
          label: '',
          field: 'opt',
        },
      ];

      this.tableConfig.columns = tempColumns;
    },
  },
  async mounted() {
    this.initColumns();
  },
};
</script>

<style scoped>
#disciplineMain >>> .custom-main-table thead {
  background-color: #3f5b60 !important;
  padding: 5px 5px 5px 5px;
  margin-top: 20px;
  border-radius: 4px;
  width: 1165px;
  float: left;
}

#disciplineMain >>> .custom-main-table thead tr th {
  border-bottom: 0px;
  border-top: 0px;
  width: 375px !important;
  height: 17px;
  float: left;
}

#disciplineMain >>> .custom-main-table thead tr th span {
  color: #fff;
  float: left;
  margin-left: 10px;
}

#disciplineMain >>> .custom-main-table tbody tr td {
  border-top: none !important;
  padding-top: 2px;
  width: 29%;
  padding: 15px 0px 10px 45px;
}

#disciplineMain >>> .custom-main-table tbody tr {
  border-bottom: #e8e8e8;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

#disciplineMain >>> .custom-main-table tbody {
  margin-top: 10px;
  float: left;
  width: 99%;
}

.info {
  margin-left: 85px;
}

@media (min-width: 992px) {
  #disciplineMain[data-v-114f7edd] .custom-main-table tbody {
    width: 70% !important;
  }
}

.custom-btn-report {
  border: 1px solid #2db782;
  font-weight: bold;
  width: 125px;
  float: left;
}

.custom-btn-report:hover {
  background-color: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}
</style>
